"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".host_1500d8b3{display:inline}\n" }]);
exports.host = "host_1500d8b3";
//# sourceMappingURL=TooltipHost.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Tooltip/TooltipHost.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Tooltip/TooltipHost.scss.js
// module chunks = 1